import { Poll } from '../../../../../db/polls/types';
import { getIsActivityPublished } from '../../../../../utils/activities';

export function getCanEditPollStudentResponses(poll: Poll | undefined) {
  if (!poll) return false;

  const isPollPublished = getIsActivityPublished(poll);
  return !isPollPublished;
}
